<div *ngIf="loading" class="d-flex py-4">
  <div class="spinner-border text-primary mx-auto" role="status" aria-hidden="true"></div>
</div>

<div class="card" *ngIf="!loading && !entries.length">
  <div class="card-body">
    No subscriptions recorded for this member.
  </div>
</div>

<div class="card mb-4" *ngFor="let entry of entries">
  <div class="card-header row gx-3 gy-2">
    <div class="col-auto my-auto">
      <h4 class="mb-0">{{ productLabel(entry.subscription) }}</h4>
      <span class="text-muted small">
        {{ entry.subscription.status }}
        &middot; paid until {{ entry.subscription.expiryDate | date : 'd/MM/yyyy' }}
        &middot; {{ renewalLabel(entry.subscription) }}
      </span>
    </div>
    <div class="col-auto ms-auto my-auto">
      <button
        class="btn btn-primary rounded-pill px-4 py-2"
        type="button"
        (click)="editRule(entry)"
      >
        Renewal rule
      </button>
    </div>
  </div>
  <div class="card-body">
    <div *ngIf="entry.eventsLoading" class="d-flex py-3">
      <div class="spinner-border text-primary mx-auto" role="status" aria-hidden="true"></div>
    </div>
    <span *ngIf="!entry.eventsLoading && !entry.events.length">
      No events recorded for this subscription.
    </span>
    <div *ngIf="!entry.eventsLoading && entry.events.length" class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr class="table-row table-row-head text-nowrap">
            <th>Event</th>
            <th>Billing month</th>
            <th>Effective date</th>
            <th>Paid until</th>
            <th>Recorded</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr *ngFor="let event of entry.events" class="table-row">
            <td>
              <span
                class="text-uppercase badge xsmall rounded-2 w-fit-content"
                [ngClass]="eventBadgeClass(event)"
              >
                {{ eventLabel(event) }}
              </span>
            </td>
            <td>{{ event.billingMonth }}</td>
            <td class="text-nowrap">{{ event.effectiveDate | date : 'd/MM/yyyy' }}</td>
            <td class="text-nowrap">{{ event.newExpiryDate | date : 'd/MM/yyyy' }}</td>
            <td class="text-nowrap">{{ event.eventDate | date : 'd/MM/yyyy HH:mm' }}</td>
            <td>{{ event.notes }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-subscription-rule-modal
  #ruleModal
  [schoolId]="schoolId"
  (saved)="onRuleSaved($event)"
></app-subscription-rule-modal>
